import { GetURLPath } from "../../../../utils"

import Logo from "@assets/auth/Logo.png"

export const AuthContentConst = {

    "/auth/log-in": {
        img: Logo,
        caption: "Login_Caption",
        title: "login-title",
    },
    "/forget-password": {
        img: Logo,
        title: "Send Code",
    },
    "/verify-account": {
        img: Logo,
        caption: "Login_Caption",
        title: "login-title",
    },
    "/reset-password": {
        img: Logo,
        caption: "Login_Caption",
        title: "ResetPassword",
    },

}

export const  GetHeaderData =()=> AuthContentConst[GetURLPath()] || {
    img: "@assets/auth/Logo.png",
    caption: "Login_Caption",
    title: "login-title",
}